import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


export const PostSlider = ({ posts, description = false }) => {
    return (
        <Container className='px-lg-5 mx-lg-5 '>
            <div className="slider-row" >
                {
                    posts.map(post => (
                        
                            <PostSlideItem post={post} description={description} key={post.slug} />
                        
                    ))
                }
            </div>
        </Container>
    )
}


const PostSlideItem = ({ post, description = false }) => {
    const navigate = useNavigate();
    const handlePostClick = useCallback((slug) => navigate(`/blog/${slug}`), [navigate]);

    return (
        <div className="h-100 w-100 p-3 post-slide-item" onClick={()=> handlePostClick(post.slug)}>
            <img src={post.image} alt={`cover post for ${post.title}`} className=" post-slide-img" />
            <div className="pt-4">
                <h2>{ post.title }</h2>
                { description && <div className="mb-4">{ post.description }</div> }
            </div>
        </div>
    )
}